import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ReactNode } from 'react';

interface TopBarProps {
  title: string;
  back?: boolean | string;
  right?: ReactNode;
}

export function TopBar({ title, back, right }: TopBarProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (typeof back === 'string') navigate(back);
    else navigate(-1);
  };

  return (
    <header className="sticky top-0 z-30 bg-white border-b border-gray-100 px-4 pt-safe">
      <div className="flex items-center h-14 gap-2">
        {back !== undefined && (
          <button
            onClick={handleBack}
            className="p-2 -ml-2 rounded-xl text-gray-600 hover:bg-gray-100 active:bg-gray-200 transition-colors"
            aria-label="Go back"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        )}
        <h1 className="flex-1 font-semibold text-gray-900 text-lg truncate">{title}</h1>
        {right && <div className="flex items-center gap-1">{right}</div>}
      </div>
    </header>
  );
}
